// Copied from packages/ui/src/StructuredContentRenderer/utils.ts because the Tailwind
// graph may not import @ria-client/ui. This duplicates logic that NWA-3985 was
// meant to move into @ria-client/content-domain. Reconcile when 3985 lands.
import type { StructuredContent, StructuredContentDocument } from '../types';
import { isStructuredContent } from '../types';

export function groupedByH2ContentAndWrapItWithContainer(
  doc: StructuredContentDocument<Record<string, unknown>>,
): StructuredContent {
  if (doc?.type !== 'Document' || !Array.isArray(doc?.props?.children)) return doc;

  const wrappedChildren: StructuredContent[] = [];
  let currentSection: StructuredContent[] | undefined;

  for (const child of doc.props.children) {
    if (!isStructuredContent(child)) {
      wrappedChildren.push(child);
      continue;
    }

    const isH2 =
      child.type === 'Container' &&
      Array.isArray(child.props?.children) &&
      isStructuredContent(child.props.children[0]) &&
      child.props.children[0].type === 'ContentHeading' &&
      child.props.children[0].props?.level === 2;

    if (isH2) {
      if (currentSection) {
        wrappedChildren.push({
          type: 'ContentSection',
          version: '1.0.0',
          props: { spacing: { bottom: 3 }, children: currentSection },
        });
      }
      currentSection = [child];
    } else if (currentSection) {
      currentSection.push(child);
    } else {
      wrappedChildren.push(child);
    }
  }

  if (currentSection) {
    wrappedChildren.push({
      type: 'ContentSection',
      version: '1.0.0',
      props: { spacing: { bottom: 3 }, children: currentSection },
    });
  }

  return { ...doc, props: { ...doc.props, children: wrappedChildren } };
}
